import { SxProps, Theme } from '@mui/material';
import { ZIndex } from '@/utils/zIndex';

export const modalRootSX: SxProps<Theme> = { zIndex: ZIndex.HIGHEST };

export const modalSX: SxProps<Theme> = { padding: 0 };

export const dialogContainerSX: SxProps<Theme> = {
	backgroundColor: '#FFFFFF',
	position: 'absolute',
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
	height: 'auto',
	top: { xs: 'auto', sm: '50%' },
	bottom: { xs: 0, sm: 'auto' },
	left: { xs: 0, sm: '50%' },
	right: { xs: 0, sm: 'auto' },
	transform: { xs: 'none', sm: 'translate(-50%, -50%)' },
	width: { xs: '100%', sm: '660px' },
	maxWidth: { xs: '100%', sm: 'calc(100vw - 32px)' },
	maxHeight: { xs: '90dvh', sm: '70vh' },
	borderRadius: { xs: '12px 12px 0 0', sm: '6px' },
	padding: { xs: '34px 20px 24px', sm: '40px 36px 32px' },
	boxSizing: 'border-box',
	outline: 'none',
};

export const closeButtonSX: SxProps<Theme> = {
	position: 'absolute',
	right: { xs: '7px', sm: '10px' },
	top: { xs: '7px', sm: '10px' },
	fontSize: '24px',
	color: '#1F1F1F',
	padding: '4px',
	'&:hover': {
		backgroundColor: 'transparent',
		color: '#1F1F1F',
	},
};

export const contentSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	minHeight: 0,
	overflow: 'hidden',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
};

export const titleSX: SxProps<Theme> = {
	color: '#2C2C2C',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
	fontSize: { xs: '18px', sm: '22px' },
	fontWeight: 800,
	lineHeight: { xs: '22px', sm: '26px' },
	margin: 0,
	textTransform: 'uppercase',
	textAlign: { xs: 'center', sm: 'left' },
};

export const descriptionSX: SxProps<Theme> = {
	color: '#5A5A5A',
	fontFamily: 'Open Sans, Helvetica Neue, Arial, sans-serif',
	fontSize: '13px',
	fontWeight: 400,
	lineHeight: '18px',
	margin: { xs: '4px 0 14px', sm: '5px 0 16px' },
	textAlign: { xs: 'center', sm: 'left' },
};

export const couponBannerSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '6px',
	backgroundColor: '#F4F4F4',
	borderRadius: '6px',
	padding: { xs: '12px 14px', sm: '14px 16px' },
	boxSizing: 'border-box',
};

export const couponTopRowSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'column', sm: 'row' },
	alignItems: 'center',
	justifyContent: { xs: 'center', sm: 'space-between' },
	gap: { xs: '8px', sm: '10px' },
};

export const couponLabelGroupSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '2px',
	minWidth: 0,
	alignItems: { xs: 'center', sm: 'flex-start' },
	textAlign: { xs: 'center', sm: 'left' },
};

export const couponEyebrowSX: SxProps<Theme> = {
	color: '#6B6B6B',
	fontSize: '12px',
	lineHeight: '16px',
};

export const couponLabelSX: SxProps<Theme> = {
	color: '#1F1F1F',
	fontSize: { xs: '13px', sm: '14px' },
	fontWeight: 800,
	lineHeight: '18px',
	textTransform: 'uppercase',
};

export const couponCodeButtonSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	gap: '8px',
	border: '1px dashed #774A91',
	borderRadius: '999px',
	padding: '8px 12px',
	flex: '0 0 auto',
	width: { xs: '100%', sm: 'auto' },
	maxWidth: { xs: '260px', sm: 'none' },
};

export const couponCodeSX: SxProps<Theme> = {
	color: '#774A91',
	fontSize: '18px',
	fontWeight: 800,
	letterSpacing: '0.4px',
};

export const couponCopyIconSX: SxProps<Theme> = {
	color: '#774A91',
	fontSize: '16px',
};

export const couponExpirySX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: { xs: 'center', sm: 'flex-start' },
	gap: '5px',
	color: '#D8472B',
	fontSize: '12px',
	fontWeight: 600,
};

export const couponExpiryIconSX: SxProps<Theme> = {
	fontSize: '14px',
};

export const productListSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	flex: 1,
	minHeight: 0,
	overflowY: 'auto',
	margin: { xs: '4px 0 0', sm: '6px 0 0' },
};

export const productRowSX: SxProps<Theme> = {
	display: 'flex',
	alignItems: 'center',
	gap: { xs: '10px', sm: '14px' },
	padding: '14px 0',
	borderBottom: '1px solid #EFEFEF',
};

export const productImageFrameSX: SxProps<Theme> = {
	width: { xs: '64px', sm: '72px' },
	height: { xs: '64px', sm: '72px' },
	backgroundColor: '#F2F2F2',
	flex: '0 0 auto',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	overflow: 'hidden',
	borderRadius: '4px',
};

export const productImageSX: SxProps<Theme> = {
	width: '100%',
	height: '100%',
	objectFit: 'contain',
	display: 'block',
};

export const productInfoSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: 'column',
	gap: '6px',
	flex: 1,
	minWidth: 0,
};

export const productNameSX: SxProps<Theme> = {
	color: '#2C2C2C',
	fontSize: '14px',
	fontWeight: 600,
	lineHeight: '18px',
	margin: 0,
};

export const productPriceSX: SxProps<Theme> = {
	color: '#1C1C1C',
	fontSize: '14px',
	fontWeight: 700,
	lineHeight: '18px',
};

export const actionsSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'column-reverse', sm: 'row' },
	gap: '12px',
	width: '100%',
	marginTop: { xs: '20px', sm: '24px' },
};

export const actionItemSX: SxProps<Theme> = {
	flex: 1,
	display: 'flex',
};

export const actionButtonSX: SxProps<Theme> = {
	minHeight: '44px',
	fontSize: '14px',
	fontWeight: 800,
	lineHeight: '18px',
	textTransform: 'none',
	borderRadius: '22px',
};

export const productPriceSizeRowSX: SxProps<Theme> = {
	display: 'flex',
	flexDirection: { xs: 'row', sm: 'column' },
	alignItems: { xs: 'center', sm: 'flex-start' },
	justifyContent: { xs: 'space-between', sm: 'flex-start' },
	gap: '6px',
};
